import React from 'react'

const PaperWarning = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='122'
    height='126'
    viewBox='0 0 122 126'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <svg
      width='122'
      height='128'
      viewBox='0 0 122 128'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M40.7508 90.5H81.2446V80.5H40.7508V90.5ZM40.7508 70.5H81.2446V60.5H40.7508V70.5ZM30.6274 110.5C27.8434 110.5 25.4602 109.521 23.4777 107.562C21.4952 105.604 20.5039 103.25 20.5039 100.5V20.5C20.5039 17.75 21.4952 15.3958 23.4777 13.4375C25.4602 11.4792 27.8434 10.5 30.6274 10.5H71.1212L101.492 40.5V100.5C101.492 103.25 100.5 105.604 98.5178 107.562C96.5353 109.521 94.1521 110.5 91.3681 110.5H30.6274ZM66.0595 45.5V20.5H30.6274V100.5H91.3681V45.5H66.0595Z'
        fill='currentColor'
      />
      <rect x='75' y='91.5' width='36' height='36' rx='18' fill='white' />
      <path
        d='M91.4961 117H94.4961V108H91.4961V117ZM92.9961 105C93.4211 105 93.7773 104.856 94.0648 104.569C94.3523 104.281 94.4961 103.925 94.4961 103.5C94.4961 103.075 94.3523 102.719 94.0648 102.431C93.7773 102.144 93.4211 102 92.9961 102C92.5711 102 92.2148 102.144 91.9273 102.431C91.6398 102.719 91.4961 103.075 91.4961 103.5C91.4961 103.925 91.6398 104.281 91.9273 104.569C92.2148 104.856 92.5711 105 92.9961 105ZM92.9961 124.5C90.9211 124.5 88.9711 124.106 87.1461 123.319C85.3211 122.531 83.7336 121.462 82.3836 120.112C81.0336 118.762 79.9648 117.175 79.1773 115.35C78.3898 113.525 77.9961 111.575 77.9961 109.5C77.9961 107.425 78.3898 105.475 79.1773 103.65C79.9648 101.825 81.0336 100.237 82.3836 98.8873C83.7336 97.5373 85.3211 96.4685 87.1461 95.681C88.9711 94.8935 90.9211 94.4998 92.9961 94.4998C95.0711 94.4998 97.0211 94.8935 98.8461 95.681C100.671 96.4685 102.259 97.5373 103.609 98.8873C104.959 100.237 106.027 101.825 106.815 103.65C107.602 105.475 107.996 107.425 107.996 109.5C107.996 111.575 107.602 113.525 106.815 115.35C106.027 117.175 104.959 118.762 103.609 120.112C102.259 121.462 100.671 122.531 98.8461 123.319C97.0211 124.106 95.0711 124.5 92.9961 124.5Z'
        fill='currentColor'
      />
    </svg>
  </svg>
)

export default PaperWarning
